import { Link, usePage } from '@inertiajs/react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Charity } from '../../../Shared/types';
import { ColorBadge } from '../../../Shared/UI/ColorBadge';
import { useRouter } from '../../router';
import { PageProps, Subscription } from '../../types';
import Container from '../../UI/Container';
import Header from '../../UI/Header';
import HeaderTitle from '../../UI/HeaderTitle';
import { tabClasses } from '../../UI/helpers';
import { DonationsLayout } from '../DonationsLayout';

export function SubscriptionLayout({
  children,
}: {
  children: ReactNode;
}) {
  const { props: { charity, subscription }, component } = usePage<PageProps<{
    subscription: Subscription;
  }>>();

  return (
    <DonationsLayout>
      <SubscriptionHeader subscription={subscription} charity={charity} component={component} />
      {children}
    </DonationsLayout>
  );
}

export function SubscriptionHeader({
  subscription,
  charity,
  component,
}: {
  subscription: Subscription;
  charity: Charity;
  component?: string;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();

  return (
    <Header>
      <Container className="!pb-0">
        <div className="flex items-center justify-between w-full">
          <HeaderTitle>
            <ColorBadge
              color={charity.brand_color}
              name={subscription.company_name || subscription.full_name || subscription.email || t('backend:anonymous')}
              className="mr-3"
            />
            {subscription.company_name || subscription.full_name || subscription.email || t('backend:anonymous')}
          </HeaderTitle>
        </div>

        <div className="mt-2 space-x-4">
          <Link
            href={routes.subscription_page(subscription.id)}
            className={tabClasses({ active: component === 'Backend/Donations/Subscriptions/SubscriptionPage' })}
          >
            {t('backend:about')}
          </Link>
          <Link
            href={routes.subscription_payments_page(subscription.id)}
            className={tabClasses({ active: component === 'Backend/Donations/Subscriptions/PaymentsPage' })}
          >
            {t('backend:payments')}
          </Link>
          <Link
            href={routes.subscription_sent_mails_page(subscription.id)}
            className={tabClasses({ active: component === 'Backend/Donations/Subscriptions/SentMailsPage' })}
          >
            {t('backend:sent_emails')}
          </Link>
        </div>
      </Container>
    </Header>
  );
}
